module.exports = __webpack_public_path__ + "public/images/iterable-email-capture-box-bear-book-tent.efdd632767c76f8e5f9d8db72ad76453.webp";